import React, { useState } from "react"; // 1. Import useState
import { Link } from "react-router-dom";
import Logo from './../Assets/Logo/PulseOfTheUnderground_800x800.0404bc22.jpg'
import "./Compoments.css"


const NavigationBar = () => {
    // 2. Προσθήκη state για τον έλεγχο του collapse
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    return (
        <>
            <div className="container-fluid bg-black text-center">
                <div className="row">
                    {/* Hero Text */}
                    <div className="col-md-4">
                        <h2 className="text-white Hero border-right">Pulse Of The Underground</h2>
                    </div>
                    
                    {/* Social Bar - Διορθωμένη δομή (όχι h2) */}
                    <div className="col-md-4 social-bar d-flex justify-content-center align-items-center gap-4">
                        <a className="nav-link text-white fs-4" href="https_links_social" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-facebook"></i>
                        </a>
                        <a className="nav-link text-white fs-4" href="https_links_social" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-instagram"></i>
                        </a>
                        <a className="nav-link text-white fs-4" href="https_links_social" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-youtube"></i>
                        </a>
                    </div>

                    <div className="col-md-4 border-left">
                        <h2 className="text-white Hero">Since 2023 , the underground voice</h2>
                    </div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg Navigation_collor navbar-dark"> {/* Πρόσθεσα navbar-dark για να φαίνεται το icon */}
                <div className="container-fluid">
                    {/* 3. Αντικατάσταση 'a' με 'Link' */}
                    <Link className="navbar-brand" to="/">
                        <img className="rounded-circle logo_img" src={Logo} alt="Logo" />
                    </Link>
                    
                    {/* 4. Διορθωμένο Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse" // Χρησιμοποιούμε data-bs-toggle
                        data-bs-target="#navbarText"
                        aria-controls="navbarText"
                        aria-expanded={!isNavCollapsed ? true : false} // Δυναμικό aria-expanded
                        aria-label="Toggle navigation"
                        onClick={handleNavCollapse} // 5. Προσθήκη onClick
                    >
                        <i className="bi bi-list"></i>
                    </button>
                    
                    {/* 6. Δυναμικές κλάσεις στο div */}
                    <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarText">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ">
                            <li className="nav-item ">
                                {/* 7. Αντικατάσταση 'a' με 'Link' */}
                                <Link className="nav-link active text-white" aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white" to="/Pulse_Of_The_Underground/events">Events</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white" to="/archive">Archive</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white" to="/Pulse_of_the_underground/Editorial-Team">Editorial Team</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white" to="/Pulse_of_the_underground/About">About</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default NavigationBar;
